<template>
    <div class="body-box marginBox">
        <!-- 搜索与添加区域 -->
        <el-row class="plan" :gutter="40">
            <el-col :span="5">
                <search-input v-model="queryInfo.keyword" placeholder="请输入关键字进行搜索" @change="handleQuery"/>
            </el-col>
            <el-col :span="5">
                <search-input v-model="queryInfo.restaurantName" placeholder="请输入饭店名称进行搜索" @change="handleQuery"/>
            </el-col>
            <el-col :span="5">
                <search-input v-model="queryInfo.userName" placeholder="请输入用户名称进行搜索" @change="handleQuery"/>
            </el-col>
            <el-col :span="5">
                <search-input v-model="queryInfo.couponNameUseId" placeholder="请输入优惠券名称/使用Id进行搜索" @change="handleQuery"/>
            </el-col>
        </el-row>

        <!--列表-->
        <el-table :height="'calc(100% - 70px)'" :data="restaurantUseCouponList" class="button-box">
            <el-table-column label="饭店优惠券审核Id" prop="id"></el-table-column>
            <el-table-column label="饭店名称" prop="restaurantName"></el-table-column>
            <el-table-column label="用户id" prop="userId"></el-table-column>
            <el-table-column label="用户名称" prop="userName"></el-table-column>
            <el-table-column label="用户邮箱" prop="userEmail"></el-table-column>
            <el-table-column label="优惠券使用id" prop="useCouponId"></el-table-column>
            <el-table-column label="优惠券名称" prop="couponName"></el-table-column>
            <el-table-column label="购买方式" prop="buyType">
                <template slot-scope="scope">
                    {{scope.row.buyType === 'RMB' ? '现金':'积分'}}
                </template>
            </el-table-column>
            <el-table-column label='购买时间' prop='buyTime'>
                <template slot-scope="scope">
                    {{scope.row.buyTime | formatDate('yyyy-MM-dd hh:mm:ss')}}
                </template>
            </el-table-column>
            <el-table-column label="操作" min-width="100" fixed="right">
                <template slot-scope="scope">
                    <el-button @click="sendCoupon(scope.row.id)">发送优惠券</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页区域 -->
        <div class="fixedBox"><pagination ref="page" :query-param.sync="queryInfo" @pagination="getRestaurantUseCouponList" /></div>

    </div>
</template>
<script>
  import Pagination from '@/components/common/Pagination/index'
  import { getPostOrDeleteData } from '@/utils/code'
  import { sendCouponBatch, getRestaurantUseCouponList } from '@/api/restaurant/restaurant'
  import SearchInput from '@/components/common/searchInput/searchInput'
  import Template from '@/views/template/template'
  import { enumStatus } from '@/js/enum'
  import { formatDate } from '@/js/momen'

  export default {
    components: { Template, SearchInput, Pagination },
    data() {
      return {
        // 查询参数
        queryInfo: {
          keyword: ''
        },
        restaurantUseCouponList: []
      }
    },
    created() {
      this.handleQuery()
    },
    methods: {
      // 状态转换
      statusChange(p) {
        let text = ''
        enumStatus.forEach(res => {
          if (p === res.key) {
            text = res.value
          }
        })
        return text
      },
      //查询列表
      getRestaurantUseCouponList(page, cb) {
        getRestaurantUseCouponList(page).then((response) => {
          this.restaurantUseCouponList = cb(response)
        })
      },

      //发送优惠券
      sendCoupon(id) {
        this.$confirm('确定要发送吗, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let ids = [id]
          sendCouponBatch(ids).then((response) => {
            let data = getPostOrDeleteData(response)
            if (data !== null) {
              this.handleQuery()
            }
          })
        }).catch(() => {
        })
      },

      handleQuery() {
        this.$nextTick(() => {
          this.$refs.page.run()
        })
      },

    }
  }
</script>

<style lang="less" scoped>

</style>
